<template>
  <card v-if="hasPremium">
    <div slot="header">
      <b-row align-v="center">
        <b-col cols="8">
          <h3 class="mb-0">Notification Settings</h3>
        </b-col>
      </b-row>
      <b-row align-v="center">
        <b-col cols="8">
          <small>
            Get notified when your components have issues.
          </small>
        </b-col>
      </b-row>
    </div>

    <b-form @submit.prevent="updateProfile">
      <h6 class="heading-small text-muted mb-4">Component Notifications</h6>

      <b-list-group
        v-for="(component, i) of components"
        v-bind:key="component.id"
      >
        <b-list-group-item
          class="d-flex justify-content-between align-items-center"
        >
          <span>
            <b-img
              v-if="component.faviconUrl"
              class="favicon-img"
              alt="Image placeholder"
              :src="component.faviconUrl"
            ></b-img>

            <i v-else class="favicon-img ni ni-app component-icon"></i>

            {{ component.name }}
          </span>

          <span>
            <!--
            <base-button size="sm" type="primary">
              <span class="btn-inner--icon">
                <i class="fas fa-envelope"></i>
              </span>
              <span class="btn-inner--text">
                Email
              </span>
            </base-button>
            -->
            <base-button
              size="sm"
              type="primary"
              @click="addSlackNotification(component)"
              v-if="component.notificationSubscriptions.length == 0"
              :loading="component.loading"
            >
              <span class="btn-inner--icon">
                <i class="fab fa-slack"></i>
              </span>
              <span class="btn-inner--text">
                Slack
              </span>
            </base-button>

            <base-button
              size="sm"
              type="danger"
              @click="removeSlackNotification(component, i)"
              :loading="component.loading"
              v-else
            >
              <span class="btn-inner--icon">
                <i class="fas fa-times-circle"></i>
              </span>
              <span class="btn-inner--text">
                Slack
              </span>
            </base-button>
          </span>

          <!--
          <b-badge variant="primary" pill>
            <i class="fas fa-check"></i>
            Slack
          </b-badge>
          -->
        </b-list-group-item>
      </b-list-group>
    </b-form>
  </card>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  components: {},
  data() {
    return {
      components: [],
      notificationSubscriptions: []
    };
  },
  computed: {
    ...mapGetters("user", ["hasPremium"])
  },
  methods: {
    async removeSlackNotification(component, i) {
      component.loading = true;
      this.$set(this.components, i, component);

      console.log(component);

      const resp = await this.$http.delete("/notifications/slack", {
        data: {
          component: component
        }
      });

      component.loading = false;

      // TODO: Support multiple types of subscriptions, not just slack!
      component.notificationSubscriptions = [];
      this.$set(this.components, i, component);
      this.$toasted.show("Removed slack notificaton.", {
        type: "success",
        duration: 5000
      });
    },
    addSlackNotification(component) {
      let currentUrl = `https://${window.location.hostname}/settings/notifications`;

      localStorage.slack = JSON.stringify({
        redirectUri: currentUrl,
        componentId: component.id
      });

      let webhookUrl = `https://${window.location.hostname}/handleSlackWebhook`;

      console.log(localStorage);

      const slackUrl =
        "https://slack.com/oauth/v2/authorize?client_id=786644536177.1208376345524&scope=incoming-webhook&user_scope=&redirect_uri=" +
        webhookUrl;

      console.log(slackUrl);
      window.location.href = slackUrl;
    }
  },
  async created() {
    const resp = await this.$http.get("/settings/notifications");

    /*
    const components = resp.data.components.map(c => {
      const slackNotifs = resp.data.notification_subscriptions.filter(
        ns => c.id === ns.componentId && ns.type === "slack"
      );

      // TODO: Support multiple notifications per component...
      c.slack_notifs = slackNotifs[0];
      return c;
    });
     */

    this.components = resp.data.components;
    //this.notificationSubscriptions = resp.data.notification_subscriptions;
    console.log("Loading notifications...");
    console.log(resp);
    console.log(this.components);

    if (this.$route.query && this.$route.query.code) {
      const resp = await this.$http.get("/webhook/slack", {
        params: {
          code: this.$route.query.code,
          componentId: this.$route.query.component_id,
          userId: this.$route.query.user_id,
          redirectUri: this.$route.query.boltscale_redirect_uri
        }
      });
    }
  }
};
</script>
<style>
.favicon-img {
  width: 16px;
  margin-right: 16px;
}
</style>
